import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DefaultNavBar from "components/Navbars/DefaultNavBar.js";
import LegalHeader from "components/Headers/LegalHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";

function SmsTermsPage(props) {
  React.useEffect(() => {
    document.body.classList.add("legal-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    return function cleanup() {
      document.body.classList.remove("legal-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <DefaultNavBar {...props} />
      <div className="wrapper">
        <LegalHeader title="SMS Terms" />
        <div className="section">
          <Container className="legal-content">
            <Row className="justify-content-center">
              <Col md="10" lg="8">
                <p className="last-updated">Last updated: October 20, 2026</p>
                <h3>Unlimited Transportation SMS Terms</h3>

                <p>
                  <b>Program:</b> Unlimited Transportation sends text messages
                  about dispatch and delivery assignments, such as pickup ETAs,
                  delivery confirmations, and delivery in and out times, to
                  employees who opt in. We do not send marketing or promotional
                  text messages.
                </p>

                <p>
                  <b>How to opt in:</b> Enter your mobile number and check the SMS
                  consent box on our <a href="/text-updates">Text Updates page</a>.
                  Job applicants may also check the SMS consent box on
                  our <a href="/jobs">online job application</a>; messages begin
                  only if they are hired. Consent is not a condition of
                  employment.
                </p>

                <p>
                  <b>Message frequency:</b> Varies based on your dispatch and
                  delivery activity.
                </p>

                <p>
                  <b>Costs:</b> Message and data rates may apply.
                </p>

                <p>
                  <b>Help:</b> Reply HELP for assistance, or contact us
                  at <a href="tel:614-351-0400">(614) 351-0400</a> or <a href="mailto:info@unlimitedtransportation.com">info@unlimitedtransportation.com</a>.
                </p>

                <p>
                  <b>Opt out:</b> Reply STOP at any time to stop receiving
                  messages. You'll receive one confirmation message, and no
                  further messages will be sent.
                </p>

                <p>
                  <b>Carriers:</b> Carriers are not liable for delayed or
                  undelivered messages.
                </p>

                <p>
                  <b>Privacy:</b> See our <a href="/privacy">Privacy Policy</a>.
                  We do not sell or share your mobile information with third
                  parties for marketing purposes.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <DarkFooter />
      </div>
    </>
  );
}

export default SmsTermsPage;
